import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { partnerService, Partner } from '@/services/partner-service'
import { toast } from 'sonner'

export function usePartners() {
    const queryClient = useQueryClient()

    const partnersQuery = useQuery({
        queryKey: ['partnersList'],
        queryFn: () => partnerService.getPartners(),
    })

    const createPartnerMutation = useMutation({
        mutationFn: (data: Omit<Partner, '_id'>) => partnerService.createPartner(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['partnersList'] })
            toast.success('Partner / Marka Eklendi')
        },
        onError: () => toast.error('Partner eklenemedi.')
    })

    const updatePartnerMutation = useMutation({
        mutationFn: ({ id, data }: { id: string, data: Partial<Partner> }) => partnerService.updatePartner(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['partnersList'] })
            toast.success('Partner Kaydedildi')
        },
        onError: () => toast.error('Partner güncellenemedi.')
    })

    const deletePartnerMutation = useMutation({
        mutationFn: (id: string) => partnerService.deletePartner(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['partnersList'] })
            toast.success('Partner Silindi')
        },
        onError: () => toast.error('Partner silinemedi.')
    })

    return {
        partners: partnersQuery.data || [],
        isLoading: partnersQuery.isLoading,
        isError: partnersQuery.isError,
        createPartner: createPartnerMutation.mutateAsync,
        isCreating: createPartnerMutation.isPending,
        updatePartner: updatePartnerMutation.mutateAsync,
        isUpdating: updatePartnerMutation.isPending,
        deletePartner: deletePartnerMutation.mutateAsync,
        isDeleting: deletePartnerMutation.isPending
    }
}
